const sleep = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

const minDelay = async (promise, ms) => {
  let [p] = await Promise.all([promise, sleep(ms)]);
  return p;
};

const readFileAsArrayBuffer = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = function (event) {
      resolve(event.target.result);
    };
    reader.onerror = function (error) {
      reject(error);
    };
    reader.readAsArrayBuffer(file);
  });
}

export { minDelay, readFileAsArrayBuffer }